const state = {
  jobOrders: [],
  jobOrder: {}
};

export default {
  namespaced: true,
  state,
  mutations: {
    setJobOrders(state, jobOrders) {
      state.jobOrders = jobOrders;
    },
    setJobOrder(state, jobOrder) {
      state.jobOrder = jobOrder;
    }
  },
  actions: {
    fetchJobOrders({ commit }, payload) {
      const { dontPaginate, page, paginationcount } = payload;
      if (!!dontPaginate || typeof dontPaginate === 'undefined') {
        return axios
          .get('api/v1/joborder', {
            params: { page: payload.page, paginationcount: paginationcount }
          })
          .then(response => {
            commit('setJobOrders', response.data);
          })
          .catch(error => {
            if (error.response.status == 403) {
              commit(
                'SET_SNACK_BAR',
                {
                  message: error.response.data['message'],
                  color: 'error'
                },
                { root: true }
              );
            }
          })
          .finally(() => {
            commit('SET_LOADING', false, { root: true });
          });
      } else {
        return axios.get('api/v1/joborder', { params: { paginate: 0 } }).then(response => {
          commit('setJobOrders', response.data);
        });
      }
    },
    getJobOrder({ commit }, payload) {
      return axios
        .get(`api/v1/joborder/${payload.id}`)
        .then(response => {
          commit('setJobOrder', response.data);
        })
        .catch(error => {
          if (error.response.status == 403) {
            commit(
              'SET_SNACK_BAR',
              {
                message: error.response.data['message'],
                color: 'error'
              },
              { root: true }
            );
            commit('setJobOrder', {});
          }
        })
        .catch(error => {
          if (error.response.status == 404) {
            commit(
              'SET_SNACK_BAR',
              {
                message: error.response.data['message'],
                color: 'error'
              },
              { root: true }
            );
            commit('setJobOrder', {});
          }
        });
    }
  }
};
